import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CartSidebar from '@/components/feature/CartSidebar';
import HeroSection from './components/HeroSection';
import FeaturedProducts from './components/FeaturedProducts';
import CategoryShowcase from './components/CategoryShowcase';
import TestimonialsSection from './components/TestimonialsSection';
import CtaBanner from './components/CtaBanner';

export default function Home() {
  return (
    <div className="font-inter">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedProducts />
        <CategoryShowcase />
        <CtaBanner />
        <TestimonialsSection />
      </main>
      <Footer />
      <CartSidebar />
    </div>
  );
}
